import config from '../../config';
import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {
  ADMIN_AUDIT_LOGS_PATH,
  ADMIN_FULLY_CONNECTED_PATH,
  ADMIN_GLUE_PATH,
  ADMIN_HOME_PATH,
  ADMIN_ORGANIZATION_PATHS,
  ADMIN_PRICING_PLANS_PATH,
  ADMIN_RAMP_PATH,
  ADMIN_USERS_PATH,
} from './adminPaths';

/**
 * Please note that depending on the page and condition checks, there
 * may be pages that SERVER INSTANCE admin can access as well, NOT JUST WANDB ADMINS ON SAAS.
 */
export const ADMIN_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'AdminUsage',
    },
    condition: config.ENVIRONMENT_IS_PRIVATE,
    exact: true,
    isPrivateRoute: true,
    path: ADMIN_AUDIT_LOGS_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/AuditLogs/AuditLogsPage')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'AdminOrganization',
    },
    isPrivateRoute: true,
    path: ADMIN_ORGANIZATION_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../wandb-admin/pages/OrganizationAdminPage')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'AdminPricingPlans',
    },
    isPrivateRoute: true,
    path: ADMIN_PRICING_PLANS_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../wandb-admin/pages/PricingPlanAdminPage')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'AdminUser',
    },
    isPrivateRoute: true,
    path: ADMIN_USERS_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/UsersAdminPage/UsersAdminPageRouter')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // this is an internal admin tool, so no need to track
    },
    isPrivateRoute: true,
    path: ADMIN_FULLY_CONNECTED_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/GalleryAdmin')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // this is an internal admin tool, so no need to track
    },
    isPrivateRoute: true,
    path: ADMIN_RAMP_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/Ramp/RampAdmin')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via HOME_NESTED_ROUTES
    },
    isPrivateRoute: true,
    path: ADMIN_GLUE_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/HomePage/HomePageWithData')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'AdminHome',
    },
    isPrivateRoute: true,
    path: ADMIN_HOME_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../wandb-admin/pages/HomeAdminPage')
    ).Component,
  },
];
